import { Stack, Typography } from '@mui/material';
import { IEquipmentPrevOrder } from 'API';
import { shorterDateFormat } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { format } from 'date-fns';

interface ITitle {
  requestNumber?: string;
  order: IEquipmentPrevOrder;
}

export const Title = ({ requestNumber, order }: ITitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const medicationsDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const isDesktop = useIsDesktop();

  const getValidityText = (startDate?: Date, endDate?: Date) => {
    if (!startDate) return medicationsDictionary.Immediate;
    if (startDate && endDate) {
      return `${format(new Date(startDate), shorterDateFormat)} ${
        medicationsDictionary.until
      } ${format(new Date(endDate), shorterDateFormat)}`;
    } else {
      return '';
    }
  };

  return (
    <Stack>
      <Stack gap={isDesktop ? '16px' : '8px'}>
        <Typography variant={'h2'} color={'text.secondary'} tabIndex={0}>
          {`${dictionary.orderDialog.orderNum} ${
            requestNumber
              ? requestNumber
              : dictionary.orderDialog.willBeSettledLater
          }`}
        </Typography>
      </Stack>

      <Stack mt={2}>
        <Typography>
          {dictionary.orderDialog.validity}{' '}
          {getValidityText(order.startDate, order.endDate)}
        </Typography>
      </Stack>
    </Stack>
  );
};
